module.exports = __webpack_public_path__ + "static/media/skill-level.4250f3ac.svg";